import React from 'react'
import { LinkProp } from '../../../../common/props'
import { useLaunchModalContext } from '../../../../contexts/LaunchModalContext'
import { HeadlineText, CaptionText, SlideContainer, SlideLink } from './style'

const CarouselContent: React.VFC<{
  caption?: string
  headline: string
  link?: LinkProp
  index: number
  dataTaktId: string
}> = ({ caption = '', headline, link, index, dataTaktId }) => {
  const { activeIndex } = useLaunchModalContext()
  return (
    <SlideContainer isActive={activeIndex === index} isFirstSlide={false} isLastSlide={false}>
      <HeadlineText type="h3">{headline}</HeadlineText>
      <CaptionText fontSize="base">{caption}</CaptionText>
      {link && (
        <SlideLink href={link.link} data-takt-id={`${dataTaktId}_slide-${index}-link`}>
          {link.label}
        </SlideLink>
      )}
    </SlideContainer>
  )
}

export default CarouselContent
